import promiseDelay from './promiseDelay';

const setVideoConstraintsWithRetries = async (track, constraints, timeoutMs = 1000) => {
  const backoffMs = 10;
  let retries = Math.floor(timeoutMs / backoffMs);
  while (retries-- > 0) {
    const { width, height, frameRate } = track.getSettings();
    if (width && height && frameRate) {
      return track.applyConstraints(constraints);
    }
    await promiseDelay(backoffMs);
  }
  throw new Error('Failed to apply constraints to a track without width, height, and frameRate');
};

export default setVideoConstraintsWithRetries;
